import { Outlet } from "react-router-dom";

export default function ChargerSection() {
  return <Outlet />;
}
